import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import { parseN } from './utils';


const PickerModal = ({ onConfirm, onHide, additionalData }) => {
  const [step, setStep] = useState(0);
  const d = new Date();

  const [year, month, day] = additionalData.date.split('-').map(Number);
  const correctedDate = additionalData.date ? `${year}-${parseN(month - 1)}-${parseN(day)}` : '';
  
  const originalDate = correctedDate ||
    `${d.getFullYear()}-${parseN(d.getMonth())}-${parseN(d.getDate())}`;
  const originalTime = additionalData.time || `${parseN(d.getHours())}:00`;

  const [date, setDate] = useState(originalDate);
  const [time, setTime] = useState(originalTime);

  const proceedToDate = () => {
    setStep(1);
  };

  const goBack = () => {
    setStep(0);
  };

  const saveDateAndTime = () => {
    const [year, month, day] = date.split('-').map(Number);
    const displayDate = date ? `${year}-${parseN(month + 1)}-${parseN(day)}` : '';
    onConfirm({ date: displayDate, time });
  };

  if (step === 0) {
    return (
      <DatePicker
        value={date}
        setDate={setDate}
        onClose={onHide}
        onProceed={proceedToDate}
      />
    );
  }

  return (
    <TimePicker
      value={time}
      onGoBack={goBack}
      onSave={saveDateAndTime}
      setTime={setTime}
    />
  );
};


PickerModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  additionalData: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
  }),
};

export default PickerModal;
